import * as PropTypes from 'prop-types';
import * as React from 'react';

import { IOfferHelper } from '../../../presenter';
import { IOffer } from '../../../types/offer';

import * as styles from './index.css';

export interface IDeadlineContext {
  offer: IOffer;
  offerHelper: IOfferHelper;
}

export class Deadline extends React.Component {
  public context: IDeadlineContext;

  public static contextTypes = {
    offer: PropTypes.object,
    offerHelper: PropTypes.object,
  };

  public render() {
    const offer = this.context.offerHelper;

    if (
      this.context.offer.offerType === 'commercial' ||
      this.context.offer.offerType === 'suburban' ||
      offer.isRent()
    ) {
      return null;
    }

    const buildingDeadline = offer.presenters.getBuildingDeadline();

    if (!buildingDeadline) {
      return null;
    }

    return (
      <div className={styles['deadline']}>
        {`${buildingDeadline.charAt(0).toUpperCase()}${buildingDeadline.substring(1)}`}
      </div>
    );
  }
}
